<template>
  <div>
    <HeaderVideos></HeaderVideos>
    <main>
      <h3 v-if="errorMsg">{{errorMsg}}</h3>
      <h3 v-if="!list.length && !errorMsg">There are no video entries. Be the first to join!</h3>
      <section v-if="list.length">
        Sort by:
        <div class="videoSort" :class="{selected: sortBy === 'new'}" @click="onSort('new')">Newest</div>
        <div class="videoSort" :class="{selected: sortBy === 'likes'}" @click="onSort('likes')">Likes</div>
        <div class="videoSort" :class="{selected: sortBy === 'old'}" @click="onSort('old')">Oldest</div>
        <div class="videoSort" :class="{selected: sortBy === 'atoz'}" @click="onSort('atoz')">Name A to Z</div>
        <div class="videoSort" :class="{selected: sortBy === 'ztoa'}" @click="onSort('ztoa')">Name Z to A</div>
        <div class="videoList clear">
          <div v-for="(video, index) in list" :key="index" class="item" @click="onShowSolo(video._id)">
            <div class="thumb">
              <img :src="video.thumb" alt="">
            </div>
            <div class="content">
              <h3>{{ video.title }}</h3>
              <div class="author">by <b>{{ video.author}}</b></div>
              <div class="days">{{ getTime(video.date) }}</div>
              <div class="likes">❤️ {{ video.likes }}</div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <ul>
            <li :class="{selected: page == currentPage}" v-for="(page, index ) in generatePages(pageCount)" :key="index" @click="onChangePage(page)">{{ page }}</li>
          </ul>
        </div>
        <div class="alignCenter">
          <router-link to="/" class="button">Join them for the chance to win</router-link>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
import { api } from '@/config'
import getVideoThumb from '@/utils/getVideoThumb'
import getTimeDifference from '@/utils/getTimeDifference'
import axios from 'axios'
import HeaderVideos from './../components/template/HeaderVideos'

export default {
  name: 'Video',
  components: {
    HeaderVideos
  },
  data() {
    return {
      list: [],
      pageCount: 1,
      currentPage: 1,
      sortBy: 'new', // can be: new, old, atoz, ztoa
      errorMsg: ''
    }
  },
  mounted() {
    this.currentPage = this.$route.query.page || 1
    this.makeNewRequest(this.currentPage)
  },
  methods: {
    getTime(date) {
      return getTimeDifference(date)
    },
    onShowSolo(id) {
      this.$router.push({
        name: 'video',
        query: { id }
      })
    },
    onSort(sort) {
      if (sort === this.sortBy) return
      this.currentPage = 1
      this.$router.push('?page=1')
      this.sortBy = sort
      this.makeNewRequest(1, sort)
    },
    onChangePage(page) {
      this.currentPage = page
      this.makeNewRequest(page)
      this.$router.push('?page=' + page)
    },
    makeNewRequest(page, order) {
      axios.post(api.videoList, { order, page }).then(response => {
        let allPromises = []
        response.data.data.submissions.map((item) => {
          allPromises.push(getVideoThumb(item.link))
        })
        Promise.all(allPromises).then((item) => {
          this.list = item.map((link, index) => {
            return {
              ...response.data.data.submissions[index],
              thumb: link
            }
          })
        })
        .catch((e) => {
        })

        this.pageCount = response.data.data.count
        if (page > this.pageCount) {
          this.onChangePage(this.pageCount)
        }
      }).catch(err => {
        this.errorMsg = 'There was a database error. Please contact customer support.'
        console.log(err)
      })
    },
    generatePages(count) {
      const arr = []
      for (let i = 1; i <= count; i++) {
        arr.push(i)
      }
      return arr
    }
  }
}
</script>
<style lang="scss" scoped>
.button {
  margin-top: 0;
}
</style>
